import { jsx } from "react/jsx-runtime";
import { RentalCarSelection } from "./selections/CarsSelection/index.js";
import { FlightSelection } from "./selections/FlightsSelection/index.js";
import { HotelSelection } from "./selections/HotelsSelection/index.js";
function RecentSelection(props) {
    switch(props.productType){
        case 'hotels':
            return /*#__PURE__*/ jsx(HotelSelection, {
                ...props
            });
        case 'cars':
            return /*#__PURE__*/ jsx(RentalCarSelection, {
                ...props
            });
        case 'flights':
            return /*#__PURE__*/ jsx(FlightSelection, {
                ...props
            });
        default:
            return null;
    }
}
export { RecentSelection };
